import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    popup: {
      open: false,
      content: ''
    },

    message: {
      open: false,
      type: '',
      message: ''
    },

    booking: {
      vehiclecategoryid: null,
      pickuplocationid: '',
      pickupdate: new Date(),
      pickuptime: '08:00',
      dropofflocationid: '',
      dropoffdate: new Date(),
      dropofftime: '08:00',
      ageid: 9,
      vehiclecategorytypeid: "0",
      campaigncode: '',
      return: false,
      vehicle: {},
      totals: {}
    },

    cart: {
      total: 0,
      subtotal: 0,
      insurance: 0,
      gst: 0,
      optionals: []
    },

    notice: true,

    vehicles: [],
    insuranceOptions: [],
  },
  mutations: {
    setPopup (state, data) {
      state.popup = data
    },

    setToastMessage (state, data) {
      state.message = data
    },

    setNotice (state, bool) {
      // only close if mobile-width version
      state.notice = bool
    },

    setBooking (state, form) {
      state.booking = form
    },

    setVehicles (state, vehicles) {
      state.vehicles = vehicles
    },

    setInsuranceOptions (state, insuranceOptions) {
      state.insuranceOptions = insuranceOptions
    },

    setCart (state, form) {
      state.cart = form
    },
  },
  getters: {},
  actions: {}
})
